import { render, staticRenderFns } from "./skill_requirement.vue?vue&type=template&id=727d677d&scoped=true&"
import script from "./skill_requirement.vue?vue&type=script&lang=js&"
export * from "./skill_requirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727d677d",
  null
  
)

export default component.exports